import { render, staticRenderFns } from "./my-contacts-print.vue?vue&type=template&id=544f04aa&scoped=true&"
import script from "./my-contacts-print.vue?vue&type=script&lang=js&"
export * from "./my-contacts-print.vue?vue&type=script&lang=js&"
import style0 from "./my-contacts-print.vue?vue&type=style&index=0&id=544f04aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f04aa",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
